module.exports = __webpack_public_path__ + "static/media/mage.cdfcab96.png";